import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "../App";
import Inicio from "../views/Inicio";
import ArticulosRegistrados from "../views/Articulos/Articulos_registrados";
import ArticulosRegistrar from "../views/Articulos/registrar_articulos";
import SubCategorias from "../views/Articulos/subcategorias";
import PlandeCuentas from "../views/Articulos/plan_cuentas";
import TipoCategorias from "../views/Articulos/tipo_categorias";
import Categorias from "../views/Articulos/categorias";
import Almacen from "../views/Almacen/almacenes";
import TipoAlmacen from "../views/Almacen/tipo_almacen";
import UbicacionAlmacen from "../views/Almacen/ubicacion_almacen";
import Compras from "../views/Compras/gestion_compras";
import Importaciones from "../views/Compras/importacion";
import Proveedores from "../views/Compras/proveedores";
import TipoProveedores from "../views/Compras/tipo_proveedor";
import ControlInventario from "../views/Inventario/control_inventario";
import Colores from "../views/Inventario/colores";
import Unidades from "../views/Inventario/unidades";
import Paises from "../views/Configuracion/paises";
import Ciudades from "../views/Configuracion/ciudades";
import Usuarios from "../views/Usuarios/usuarios";
import Perfiles from "../views/Usuarios/perfiles";
import Permisos from "../views/Usuarios/permisos";
import Page404 from "../components/page404";
import Exitoso from "../views/Articulos/registroexitoso";
import ArticulosEditar from "../views/Articulos/articulos_editar";
import ArticuloActualizado from "../views/Articulos/ArtActualizado";
import DetallesCompras from "../views/Compras/detallescompras";
import ReportCompra from "../views/Compras/reportcompra";
import DetallesControl from "../views/Inventario/detallescontrol";
import InventarioDetalles from "../views/Inventario/inventariodetalles";
import DatosUsuarios from "../views/Usuarios/datosusuarios";
import CargarImagen from "../components/cargarimagen.";
import Bitacora from "../views/Bitacora/bitacora";
import Referidos from "../views/Articulos/Referidos";
import Depcancelados from "../views/Almacen/depcance";
import Profesor from "../views/Profesores/Profesor";
import Eventos from "../views/Eventos/Eventos";
import Clases from "../views/Clases/Clases";
import Instrumentos from "../views/Instrumentos/Instrumentos";
import Retiros from "../views/Retiros/Retiros";
import Lecciones from "../views/Lecciones/Lecciones";
import Datosbancarios from "../views/Datosbancarios/Datosbancarios";
import Historialchat from "../views/Historial/Historialchat";
import Historialsesion from "../views/Historial/Historialsesion";
import Comprasdacapo from "../views/Comprasdacapo/Comprasdacapo";
import Nosotros from "../views/Nosotros";
import Servicios from "../views/Servicios";
import Productos from "../views/Productos";
import Comunidad from "../views/Comunidad";
import Noticias from "../views/Noticias";
import Contacto from "../views/Contacto";
import Entrada1 from "../views/Espacios_de_trabajo_para_todos";
import Entrada2 from "../views/Hogar_accesible_vida_autonoma";

const Router = () => {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<Page404 />}/>
          <Route path="/hogar-accesible-vida-automata" element={<Entrada2/>}/>
          <Route path="/espacio-de-trabajo-para-todos" element={<Entrada1/>}/>
          <Route path="/Comprasdacapo" element={<Comprasdacapo/>}/>
          <Route path="/Historialsesion" element={<Historialsesion/>}/>
          <Route path="/Historialchat" element={<Historialchat/>}/>
          <Route path="/Datosbancarios" element={<Datosbancarios/>}/>
          <Route path="/Lecciones" element={<Lecciones/>}/>
          <Route path="/instrumentos" element={<Instrumentos/>}/>
          <Route path="/bitacora" element={<Bitacora/>}/>
          <Route path="/imagen" element={<CargarImagen/>}/>
          <Route path="/usuarios/info" element={<DatosUsuarios />}/>
          <Route path="/usuarios/permisos" element={<Permisos />}/>
          <Route path="/usuarios/perfiles" element={<Perfiles/>} />
          <Route path="/usuarios" element={<Usuarios/>} />
          <Route path="/ciudades" element={<Ciudades/>}/>
          <Route path="/depositostodos" element={<Paises/>} />
          <Route path="/trabajadores" element={<Colores/>} />
          <Route path="/inventario/unidades" element={<Unidades />}/>
          <Route path="/inventario/control/detalles/:idcontrol" element={<InventarioDetalles/>} />
          <Route path="/inventario/control/:id" element={<DetallesControl/>} />
          <Route path="/inventario" element={<ControlInventario/>} />
          <Route path="/compras/report/:idcompra" element={<ReportCompra/>} />
          <Route path="/compras/tipoproveedores" element={<TipoProveedores/>} />
          <Route path="/compras/proveedores" element={<Proveedores />}/>
          <Route path="/retirosprocesados" element={<Importaciones/>} />
          <Route path="/compras/detalles/:idcompra" element={<DetallesCompras/>} />
          <Route path="/retiros" element={<Retiros/>} />
          <Route path="/tusdepositos" element={<UbicacionAlmacen/>} />
          <Route path="/depositoscancelados" element={<Depcancelados />}/>
          <Route path="/depositosprocesados" element={<TipoAlmacen />}/>
          <Route path="/depositos" element={<Almacen/>} />
          <Route path="/articulos/actualizado" element={<ArticuloActualizado/>} />
          <Route path="/articulos/editar/:idart" element={<ArticulosEditar/>} />
          <Route path="/articulos/exitoso" element={<Exitoso/>} />
          <Route path="/articulos/tipocategorias" element={<TipoCategorias/>} />
          <Route path="/articulos/plandecuentas" element={<PlandeCuentas/>} />
          <Route path="/articulos/subcategorias" element={<SubCategorias/>} />
          <Route path="/referidos" element={<Referidos />}/>
          <Route path="/clases" element={<Clases/>} />
          <Route path="/eventos" element={<Eventos/>} />
          <Route path="/profesor" element={<Profesor/>} />
          <Route path="/usuariossstrade" element={<Categorias />}/>
          <Route path="/articulos/registrar" element={<ArticulosRegistrar />}/>
          <Route path="/articulos" element={<ArticulosRegistrados/>}/>
          <Route path="/contacto" element={<Contacto/>} />
          <Route path="/noticias" element={<Noticias/>} />
          <Route path="/comunidad" element={<Comunidad/>} />
          <Route path="/productos" element={<Productos/>} />
          <Route path="/servicios" element={<Servicios/>} />
          <Route path="/nosotros" element={<Nosotros/>} />
          <Route path="/" element={<App/>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default Router;
